module.exports = __webpack_public_path__ + "media/images/flags/ls-0de0f907e70c37b2e86e25e29e4bdad4.svg";